<template>
    <div class="wb-radio-group">
        <WBStack align="start" gap="xsmall">
            <WBRadio v-for="option in normalizedOptions"
                     :key="option.value"
                     :label="option.label"
                     :model-value="modelValue"
                     :value="option.value"
                     :disabled="option.disabled || disabled"
                     @change="onUpdate"
            />
        </WBStack>
    </div>
</template>

<script setup lang="ts">
    import type { WBRadioGroup } from '~/src/shared/components/ui/input/WBRadio/types'
    import { get } from '~/src/shared/utils/lodash'

    const props = withDefaults(defineProps<WBRadioGroup>(), {
        modelValue: '',
        name: null,
        valueAttribute: 'value',
        optionAttribute: 'label',
        disabled: false
    })

    const emit = defineEmits<{
        'update:modelValue': [value: any]
        change: [value: any]
    }>()

    const onUpdate = (value: any) => {
        emit('update:modelValue', value)
        emit('change', value)
    }

    const guessOptionValue = (option: any) => {
        return get(option, props.valueAttribute, get(option, props.optionAttribute))
    }

    const guessOptionText = (option: any) => {
        return get(option, props.optionAttribute, get(option, props.valueAttribute))
    }

    const guessOptionSelected = (option: any) => {
        return props.modelValue === guessOptionValue(option)
    }

    const normalizeOption = (option: any) => {
        if (['string', 'number', 'boolean'].includes(typeof option)) {
            return {
                value: option,
                label: option
            }
        }

        return {
            ...option,
            value: guessOptionValue(option),
            label: guessOptionText(option),
            selected: guessOptionSelected(option)
        }
    }

    const normalizedOptions = computed(() => {
        return props.options.map((option) => normalizeOption(option))
    })
</script>
